import Cookies from 'js-cookie'
//token的相关操作
const TokenKey = 'token'

//token信息的获取
export function getToken() {
    // return Cookies.get(TokenKey)
    // Cookies.set("token",TokenKey)
    return window.localStorage.getItem(TokenKey)
}
//token信息保存到session
export function setToken(token) {
	//为了做复制链接登录加的开始
    // Cookies.set(TokenKey, token)
	//为了做复制链接登录加的结束
    return window.localStorage.setItem(TokenKey, token)
    // return Cookies.set(TokenKey, token)
}

//移除session里面的token
export function removeToken() {
    // return Cookies.remove(TokenKey)
    return window.localStorage.removeItem(TokenKey)
}
